import React, { useEffect, useState, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { baseUrl } from "../../constants/Constant";
import { Grid, Typography } from "@material-ui/core";
import { Breadcrumb, BreadcrumbItem, Spinner } from "react-bootstrap";
import { useDeviceType } from "../../helper/useDeviceType";
import { MainContentArea, ContentSection, ProductTopTitle } from "./pages.style";
import Products from "./components/Products";
import CartPopUp from "../../containers/Cart/CartPopUp";
import { useCart } from "../../contexts/cart/use-cart";
import { useFavorites } from "../../contexts/favorites/use-favorites";
import { logPageView, logViewItem, logEventView } from '../../services/googleAnalytics';
import Notfound from "../notfound";
import t from '../../i18n/translate';

const ImageSearchResults = ({ userAgent }) => {
  const location = useLocation();
  const history = useHistory();
  let mql = window.matchMedia("all and (min-width: 991px)");
  let mqs = window.matchMedia("all and (max-width: 768px)");
  const { file } = location.state || {};
  const deviceType = useDeviceType(userAgent);
  const { fetchOrderItems } = useCart();
  const { fetchFavorites } = useFavorites();
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(null);
  const [paginate, setPaginate] = useState(1);
  const [isHasMore, setIsHasMore] = useState(true);
  // const [seenProductIds, setSeenProductIds] = useState([]);
  // const observerRef = useRef(null);

  const CenteredSpinner = () => {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1000,
        }}
      >
        <Spinner animation="border" style={{ color: "#9cc54b" }} />
      </div>
    );
  };

  const breadCrumbMatch = () => {
    return (
      <BreadcrumbItem
        className="bread_crumb_wrapper"
        style={{ display: "flex", alignItems: "center" }}
      >
        <span style={{ color: "#9cc54b" }}>
          Image Search Results
        </span>
      </BreadcrumbItem>
    );
  };

  const [historyState, setHistoryState] = useState(() => {
    try {
      const storedState = localStorage.getItem("historyState");
      return storedState ? JSON.parse(storedState) : {};
    } catch (e) {
      console.error("Failed to parse historyState:", e);
      return {};
    }
  });

  const fetchResults = (pageNum) => {
    setLoading(true);
    console.log("Fetching page:", pageNum);
    console.log("historyState:", historyState);

    const updatedHistoryState = { ...historyState, page: pageNum };

    if (pageNum === 5) {
      setIsHasMore(false);
      setLoading(false);
      return;
    }

    fetch(`${baseUrl}api/v1/product/searchImageV1`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedHistoryState),
    })
      .then((response) => {
        console.log("Response status:", response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((result) => {
        console.log("API result:", result);
        if (result.success && Array.isArray(result.data?.data)) {
          setProducts((prev) =>
            pageNum === 1 ? result.data.data : [...prev, ...result.data.data]
          );
          const newHistoryState = { ...updatedHistoryState, vector: result.data.vector };
          setHistoryState(newHistoryState);
          localStorage.setItem("historyState", JSON.stringify(newHistoryState));
          setPage({ title: "Image Search Results", is_full_width: false });
        } else {
          console.warn("No products found:", result);
          setError("No products found.");
          setIsHasMore(false);
        }
      })
      .catch((err) => {
        console.error("Fetch error:", err.message, err.stack);
        setError(`Failed to fetch search results: ${err.message}`);
        setIsHasMore(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const handleSeenProduct = (id) => {
  //   id = parseInt(id);
  //   setSeenProductIds(prev => {
  //     if (prev.includes(id)) return prev;
  //     return [...prev, id];
  //   });
  // };

  useEffect(() => {
    if (localStorage.getItem("user")) {
      fetchOrderItems();
      fetchFavorites({ type: 0 });
    }
  }, []);

  useEffect(() => {
    fetchResults(paginate);
  }, [file, paginate]);

  // useEffect(() => {
  //   if (!loading && products.length > 0) {
  //     const totalProducts = products.length;
  //     const deviceThreshold = deviceType?.mobile
  //       ? 4
  //       : deviceType?.tablet
  //       ? 6
  //       : deviceType?.desktop
  //       ? 12
  //       : 0;

  //     const seenCount = seenProductIds.length;

  //     const isMultipleOfThreshold = deviceThreshold > 0 && seenCount > 0 && seenCount % deviceThreshold === 0;

  //     const isEndOfList = seenCount === totalProducts;

  //     if (isEndOfList || isMultipleOfThreshold) {
  //       logEventView(
  //         "image-search",
  //         "",
  //         seenProductIds.length,
  //         JSON.stringify([...seenProductIds])
  //       );
  //     }
  //   }
  // }, [seenProductIds, loading, products, deviceType]);

  if (!page && !loading) {
    return <Notfound />;
  }

  return (
    <>
      {deviceType.desktop ? (
        <MainContentArea style={{ paddingTop: mql.matches ? "100px" : "0px" }}>
          <ContentSection style={{ width: "100%" }}>
            <div className="p-1 w-100">
              <div className="d-flex mt-2" style={{ width: "100%" }}>
                <Breadcrumb style={{ width: "100%" }}>
                  <BreadcrumbItem href={"/"} className="home_breadCrumb_style" style={{ display: "flex", alignItems: "center" }}>{ t('shop_address_home_label') }</BreadcrumbItem>
                  {breadCrumbMatch()}
                </Breadcrumb>
              </div>
            </div>
            <ProductTopTitle>
              Search results
            </ProductTopTitle>
            {loading && paginate === 1 ? (
              CenteredSpinner()
            ) : (
              <Products
                type="image-search"
                deviceType={deviceType}
                fetchLimit={50}
                products={products}
                error={error}
                // onSeenProduct={handleSeenProduct}
                onProductClick={(product) => {
                  logPageView(`/product/${product.item_ref_id}`);
                  logViewItem(product, `/product/${product.item_ref_id}`);
                  history.push(`/product/${product.item_ref_id}`);
                  window.scrollTo(0, 0);
                }}
                onCartClick={() => {
                  document.getElementById("joinBTn").click();
                  window.trigger = "add to cart";
                }}
                loadMore={true}
                isHasMore={isHasMore}
                loading={loading}
                onLoadMore={() => setPaginate(prev => prev + 1)}
              />
            )}
          </ContentSection>
        </MainContentArea>
      ) : (
        <MainContentArea style={{ paddingTop: mqs.matches ? "9vh" : "0px" }}>
          <ContentSection style={{ width: "100%" }}>
            <div className="p-1 w-100">
              <div className="d-flex mt-2" style={{ width: "100%" }}>
                <Breadcrumb style={{ width: "100%" }}>
                  <BreadcrumbItem href={"/"} className="home_breadCrumb_style" style={{ display: "flex", alignItems: "center" }}>{ t('shop_address_home_label') }</BreadcrumbItem>
                  {breadCrumbMatch()}
                </Breadcrumb>
              </div>
            </div>
            <ProductTopTitle>
              Search results
            </ProductTopTitle>
            {loading && paginate === 1 ? (
              CenteredSpinner()
            ) : (
              <Products
                type="image-search"
                deviceType={deviceType}
                fetchLimit={10}
                products={products}
                error={error}
                // onSeenProduct={handleSeenProduct}
                onProductClick={(product) => {
                  logPageView(`/product/${product.item_ref_id}`);
                  logViewItem(product, `/product/${product.item_ref_id}`);
                  history.push(`/product/${product.item_ref_id}`);
                  window.scrollTo(0, 0);
                }}
                onCartClick={() => {
                  document.getElementById("joinBTn").click();
                  window.trigger = "add to cart";
                }}
                loadMore={true}
                isHasMore={isHasMore}
                loading={loading}
                onLoadMore={() => setPaginate(prev => prev + 1)}
              />
            )}
          </ContentSection>
        </MainContentArea>
      )}
      <CartPopUp deviceType={deviceType} />
    </>
  );
};

ImageSearchResults.getInitialProps = async (appContext) => {
  const { req } = appContext.ctx;
  const userAgent = req ? req.headers["user-agent"] : navigator.userAgent;
  return { userAgent };
};

export default ImageSearchResults;